export const baseUrl = "https://instacart-api.onrender.com/api/v1";
// export const baseUrl = "http://127.0.0.1:4000/api/v1";
